import { render, staticRenderFns } from "./HeaderPopup.vue?vue&type=template&id=ca29a9fa&"
import script from "./HeaderPopup.vue?vue&type=script&lang=js&"
export * from "./HeaderPopup.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPopup.vue?vue&type=style&index=0&id=ca29a9fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports